export const ErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.75"
      y="0.75"
      width="22.5"
      height="22.5"
      rx="11.25"
      fill="#F43F5E"
      fillOpacity="0.1"
    />
    <rect
      x="0.75"
      y="0.75"
      width="22.5"
      height="22.5"
      rx="11.25"
      stroke="#F43F5E"
      strokeWidth="1.5"
    />
    <path
      d="M15 9L9 15"
      stroke="#F43F5E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9L15 15"
      stroke="#F43F5E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
